import { render } from "./ScienceMenu.vue?vue&type=template&id=3a5d2288"
import script from "./ScienceMenu.vue?vue&type=script&lang=js"
export * from "./ScienceMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__